import React from 'react'
import { InputGroup } from 'react-bootstrap'
import { TextInput } from '@ztechapps/webui.input'
import { BusyButton } from '@ztechapps/webui.button'
import type { FormikProps } from 'formik'
import { useFormikContext } from 'formik'

export const CreateButtonInput = ({
  loading,
  placeholder,
  buttonText = 'Create',
  ...props
}: { loading: boolean; placeholder: string; buttonText?: string } & FormikProps<any>) => {
  const { isValid } = useFormikContext()

  return (
    <InputGroup>
      <TextInput disabled={loading} autoFocus={true} placeholder={placeholder} {...props} />
      <BusyButton isBusy={loading} text={buttonText} type="submit" disabled={!isValid} />
    </InputGroup>
  )
}
